'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCombinationDefinitions = exports.parseCombinationDefinition = undefined;
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var parseTexts = function parseTexts(texts) {
  return R.reduce(function (acc, text) {
    var splitted = R.split(':', text);
    if (R.length(splitted) !== 2) {
      return acc;
    }
    var _splitted = (0, _slicedToArray3.default)(splitted, 2),
      id = _splitted[0],
      name = _splitted[1];
    return R.assoc(id, name, acc);
  }, {}, texts);
};
var parseCombinationDefinition = exports.parseCombinationDefinition = function parseCombinationDefinition(locale) {
  return function (title, texts) {
    return R.useWith(function (titles, texts) {
      return R.reduce(function (acc, title) {
        var split = R.split(':', title);
        if (R.length(split) !== 2) {
          return acc;
        }
        var _split = (0, _slicedToArray3.default)(split, 2),
          id = _split[0],
          codes = _split[1];
        if (R.isEmpty(codes)) {
          return acc;
        }
        return R.append({
          id: id,
          concepts: R.split(',', codes),
          name: R.hasPath([locale, id], texts) ? R.path([locale, id], texts) : '[' + id + ']'
        }, acc);
      }, [], titles);
    }, [R.split(';'), R.map(R.pipe(R.split(';'), parseTexts))])(title, texts);
  };
};
var getCombinationDefinitions = exports.getCombinationDefinitions = function getCombinationDefinitions(annotations, locale) {
  var annotation = R.find(function (annot) {
    return annot.type === 'COMBINED_CONCEPTS';
  }, annotations);
  if (R.isNil(annotation)) {
    return [];
  }
  var title = R.propOr('', 'title', annotation);
  var texts = R.propOr({}, 'texts', annotation);
  return parseCombinationDefinition(locale)(title, texts);
};